const rooster = {
  sendButton: {
    position: 'absolute',
    zIndex: 100,
    // set top, right to half of element width (56px) in order to "center" it.
    right: '-28px',
    top: '-28px',
  },
  sendIcon: {
    display: 'inline-block',
    height: '56px',
    width: '55%',
    userSelect: 'none',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    lineHeight: '56px',
  },
  sendIconBackground: {
    position: 'relative',
    width: '100%',
    height: '100px',
    backgroundColor: 'red',
  },
  buttonBackgroundColor: '#673ab7',
  disabledButtonColor: '#e0e0e0',
  blastMessageSendingSpinner: {
    outer: {
    },
    inner: {
      marginTop: '3px'
    }
  }
}

const tops = {
  sendIcon: {
    display: 'inline-block',
    height: '56px',
    width: '55%',
    userSelect: 'none',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    lineHeight: '56px',
  },
  sendButton: {
    position: 'absolute',
    zIndex: 100,
    // set top, right to half of element width (56px) in order to "center" it.
    right: '-28px',
    top: '-28px',
  },
  sendIconBackground: {
    position: 'relative',
    width: '100%',
    height: '100px',
    backgroundColor: 'red',
  },
  buttonBackgroundColor: '#e72da1',
  disabledButtonColor: '#e0e0e0',
  blastMessageSendingSpinner: {
    outer: {
    },
    inner: {
    }
  }
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Messages/styles/SubmitMessageButton.js